/*
 * AAS-5564 — the theme's one scroll-lock contract.
 *
 * Before this, the page was locked EIGHT different ways: five body classes
 * (overflow-hidden, -mobile, -tablet, -desktop) plus three per-component ones
 * (pdp-drawer-open, quickview-open, store-locator-drawer-open), and five files
 * that skipped classes altogether and wrote `body.style.overflow` inline. None
 * of them counted, so closing one modal unlocked the page underneath another,
 * and nothing could answer "is the page locked right now" — which the reserved
 * scrollbar gutter needs in order to paint itself with the scrim colour.
 *
 *   ScrollLock.lock('cart-drawer')                  lock until that token releases
 *   ScrollLock.lock('nav-drawer', { maxWidth: 989 })  lock only below 990px
 *   ScrollLock.unlock('cart-drawer')
 *   ScrollLock.isLocked()
 *
 * Tokens are identity, not a counter: locking twice from the same source is
 * idempotent, and a component that loses track of its own state cannot leave
 * a phantom count behind. The page unlocks when the last token is gone.
 *
 * maxWidth preserves the behaviour the -mobile/-tablet classes had, where the
 * lock applied below a breakpoint and released above it (theme.css re-set
 * `overflow: auto` at 750px and 990px). Re-evaluated on resize, so a lock taken
 * on a phone-width window releases if the window is widened past it, exactly as
 * the media query did.
 *
 * WHAT THIS DOES NOT DO: it never touches `position` on <body>. The apparel
 * lightbox pins the body (pdp-gallery-apparel-overlay.css) to stop iOS
 * rubber-banding behind a fullscreen viewer; that is a stronger lock than
 * overflow alone and it stays where it is. This only owns the overflow half and
 * the flag.
 */
(function () {
  var tokens = new Map();
  var root = document.documentElement;

  function active() {
    var w = window.innerWidth;
    for (var entry of tokens) {
      var max = entry[1];
      if (max == null || w <= max) return true;
    }
    return false;
  }

  function apply() {
    var on = active();
    root.classList.toggle('is-scroll-locked', on);
    /* Inline, because the value has to win over whatever the component's own
       class says while both exist. Cleared rather than set to '' + removed, so
       a body with other inline styles keeps them. */
    document.body.style.overflow = on ? 'hidden' : '';
  }

  var ScrollLock = {
    lock: function (token, options) {
      if (!token) return;
      tokens.set(token, (options && options.maxWidth) || null);
      apply();
    },
    unlock: function (token) {
      if (!token) return;
      tokens.delete(token);
      apply();
    },
    /* Release everything. For a navigation or a hard reset — not for ordinary
       close handlers, which must release only their own token. */
    reset: function () {
      tokens.clear();
      apply();
    },
    isLocked: function () {
      return active();
    }
  };

  window.ScrollLock = ScrollLock;
  window.addEventListener('resize', apply, { passive: true });
})();
